

import {defineComponent, PropType} from "vue";
import {VersionDataType} from "@/types/IVersionData";
import DataMixins from "@/mixins/DataMixins";
import DownloadActionMixins from "@/mixins/DownloadActionMixins";

export default defineComponent({
  name: 'ModsArchiveComponent',
  props: {
    archive_versions: {
      type: Object as PropType<VersionDataType[]>,
      required: false
    },
    title: {
      type: String,
      required: true
    }
  },
  mixins: [DataMixins, DownloadActionMixins],
  methods: {
    downloadAction(version_id: number) {
      this.downloadActionMixin(version_id, this.title)
    }
  }
})
